import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1bc8cc6a = () => interopDefault(import('../website/pages/404.vue' /* webpackChunkName: "pages/404" */))
const _1d7339c6 = () => interopDefault(import('../website/pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _5b0d8fa2 = () => interopDefault(import('../website/pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _743677c3 = () => interopDefault(import('../website/pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _2b93e804 = () => interopDefault(import('../website/pages/index.html.vue' /* webpackChunkName: "pages/index.html" */))
const _161cca21 = () => interopDefault(import('../website/pages/order.vue' /* webpackChunkName: "pages/order" */))
const _58ae0465 = () => interopDefault(import('../website/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _cedd926a = () => interopDefault(import('../website/pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _8efc20bc = () => interopDefault(import('../website/pages/catalog/details/index.vue' /* webpackChunkName: "pages/catalog/details/index" */))
const _1a3d3802 = () => interopDefault(import('../website/pages/user/loyalty.vue' /* webpackChunkName: "pages/user/loyalty" */))
const _7dce92bc = () => interopDefault(import('../website/pages/user/orders.vue' /* webpackChunkName: "pages/user/orders" */))
const _6a7f7b54 = () => interopDefault(import('../website/pages/user/restore-password/index.vue' /* webpackChunkName: "pages/user/restore-password/index" */))
const _9269634c = () => interopDefault(import('../website/pages/catalog/details/_slug.vue' /* webpackChunkName: "pages/catalog/details/_slug" */))
const _6b3786e8 = () => interopDefault(import('../website/pages/user/restore-password/_token.vue' /* webpackChunkName: "pages/user/restore-password/_token" */))
const _e38eb212 = () => interopDefault(import('../website/pages/catalog/_product_group_slug.vue' /* webpackChunkName: "pages/catalog/_product_group_slug" */))
const _055becb6 = () => interopDefault(import('../website/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _62c92832 = () => interopDefault(import('../website/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _1bc8cc6a,
    name: "404"
  }, {
    path: "/cart",
    component: _1d7339c6,
    name: "cart"
  }, {
    path: "/catalog",
    component: _5b0d8fa2,
    name: "catalog"
  }, {
    path: "/checkout",
    component: _743677c3,
    name: "checkout"
  }, {
    path: "/index.html",
    component: _2b93e804,
    name: "index.html"
  }, {
    path: "/order",
    component: _161cca21,
    name: "order"
  }, {
    path: "/search",
    component: _58ae0465,
    name: "search"
  }, {
    path: "/user",
    component: _cedd926a,
    name: "user"
  }, {
    path: "/catalog/details",
    component: _8efc20bc,
    name: "catalog-details"
  }, {
    path: "/user/loyalty",
    component: _1a3d3802,
    name: "user-loyalty"
  }, {
    path: "/user/orders",
    component: _7dce92bc,
    name: "user-orders"
  }, {
    path: "/user/restore-password",
    component: _6a7f7b54,
    name: "user-restore-password"
  }, {
    path: "/catalog/details/:slug",
    component: _9269634c,
    name: "catalog-details-slug"
  }, {
    path: "/user/restore-password/:token?",
    component: _6b3786e8,
    name: "user-restore-password-token"
  }, {
    path: "/catalog/:product_group_slug",
    component: _e38eb212,
    name: "catalog-product_group_slug"
  }, {
    path: "/",
    component: _055becb6,
    name: "index"
  }, {
    path: "/*",
    component: _62c92832,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
